<template>
    <div class="time-up">
        <div class="server-tip" v-show="companyid == 12">
            平台服务即将到期 ！
        </div>
    </div>
</template>
<script>
export default {
    name: "timeUp",
    data() {
        return {
            companyid: "",
        };
    },
    mounted() {
        this.companyid = sessionStorage.getItem("companyid");
    }
};
</script>
<style>
.server-tip {
    font-size: 13px;
    font-weight: bold;
    color: #ff0000;
    position: absolute;
    right: 8px;
    bottom: 8px;
}
</style>